<template>
  <div>
    <v-dialog v-model="isExelOpen">
      <v-card>
        <v-col align="center">
          <v-row>
            <v-col
              v-for="(content, i) in Object.values(getExelContent)"
              :key="i"
              cols="12"
            >
              <div style="font-weight: bold; font-size: 18px" class="py-2" align="left">
                {{ content.title }}
              </div>
              <!-- {{typeof  Object.values(content.ligne[0])[Object.values(content.ligne[0]).length -1] }} -->

              <vue-excel-editor
                autoFillWidth
                ref="grid"
                readonly
                :page="content.ligne.length"
                :no-mouse-scroll="true"
                v-model="content.ligne"
                :disable-panel-setting="false"
                :disable-panel-filter="true"
                no-header-edit
                no-footer
              >
                <!-- :height="'calc(24.4px * ' + (content.ligne.length + 1) + ')'" -->
                <!-- type="string"  -->
                <!-- type="number"  -->
                <vue-excel-column
                  v-for="(elem, idx) in content.colone"
                  :key="idx"
                  :field="elem.key"
                  :label="elem.label"
                  type="string"
                  :width="'calc(94vw / ' + content.colone.length + ')'"
                ></vue-excel-column>
              </vue-excel-editor>
            </v-col>
          </v-row>
          <!-- <v-btn class="mt-2" @click="exportAsExcel"> Exporter </v-btn> -->
        </v-col>
        <v-col align="center">
          <v-btn
            style="background-color: green; color: white; font-weight: bold"
            @click="exportToExcel"
            >Télécharger</v-btn
          >
        </v-col>
      </v-card>
    </v-dialog>
    <v-col class="pa-1 pt-0">
      <v-card class="pa-2">
        <div
          align="center"
          class="py-1"
          style="text-transform: uppercase; font-weight: bold"
        >
          Séléctionner l'étendu de recherche par date

          <v-btn
            icon="mdi-download"
            color="green"
            variant="tonal"
            style="position: absolute; right: 10px; top: 6px"
            density="compact"
            @click="openExelData"
          ></v-btn>
        </div>
        <v-divider class="mb-2"></v-divider>
        <v-row class="px-2">
          <v-col v-for="(elem, i) in btnListe" :key="i" class="px-1">
            <v-btn
              style="width: 100%; font-weight: bold"
              :color="selectedbtnIndex == i ? 'primary' : undefined"
              class="px-1"
              @click="setDate(elem, i)"
              :variant="selectedbtnIndex == i ? undefined : 'tonal'"
            >
              {{ elem.label }}
            </v-btn>
          </v-col>
        </v-row>
        <v-col class="px-0 pt-2 pb-0">
          <v-row
            justify="center"
            align="center"
            v-if="selectedbtnIndex != 4"
            class="px-2 pb-2 mt-0"
          >
            <v-divider class="mx-1"></v-divider>
            <v-col align="center" class="pb-1">
              <v-chip style="padding: 0px 30px">
                Date de départ : {{ formatDate(date.from, "DD/MM/YYYY") }}
              </v-chip>
            </v-col>
            <v-divider vertical class="mt-2"></v-divider>
            <v-col align="center" class="pb-1">
              <v-chip style="padding: 0px 30px">
                Date de fin : {{ formatDate(date.to, "DD/MM/YYYY") }}
              </v-chip>
            </v-col>
          </v-row>
          <v-card v-else class="pa-2" style="background-color: #e0e0e0" variant="text">
            <v-col>
              <v-row>
                <v-col align="center" v-if="selectedbtnIndex == 4" class="py-0 pl-1 pr-2">
                  Date de départ
                  <datepicker
                    style="color: white"
                    v-if="selectedbtnIndex == 4"
                    v-model="date.from"
                    locale="fr"
                    :enable-time-picker="false"
                    format="dd/MM/yyyy"
                    auto-apply
                    model-type="MM/dd/yyyy"
                    @update:modelValue="setNewDataChart"
                    :clearable="false"
                  ></datepicker>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col align="center" v-if="selectedbtnIndex == 4" class="py-0 pr-1 pl-2">
                  Date de fin
                  <datepicker
                    v-if="selectedbtnIndex == 4"
                    v-model="date.to"
                    locale="fr"
                    :enable-time-picker="false"
                    format="dd/MM/yyyy"
                    auto-apply
                    model-type="MM/dd/yyyy"
                    @update:modelValue="setNewDataChart"
                    :clearable="false"
                  ></datepicker>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
      </v-card>
    </v-col>
    <v-col
      class="pt-2 pb-0 my-1 px-3"
      style="overflow: auto; height: calc(100vh - 215px)"
    >
      <v-row
        id="captureMateriel"
        v-if="statistiqueCreatedListe && Object.keys(statistiqueCreatedListe).length != 0"
      >
        <!-- v-for="(elem, i) in statistiqueCreatedListe.sort((a,b) => a.INDEX - b.INDEX)" -->
        <v-col
          v-for="(elem, i) in statistiqueCreatedListe"
          :key="i"
          class="pa-1"
          cols="12"
          sm="12"
          :md="elem.STATS_TYPE == 'Table' ? 12 : 6"
        >
          <v-card
            class="pa-2"
            variant="text"
            style="background-color: white; border: none"
          >
            <v-row justify="center"> </v-row>
            <v-col v-if="elem.STATS_TYPE == 'Table'" class="mt-5">
              <v-col class="px-0" style="font-weight: bold">
                <h4 class="my-2">
                  {{ elem.LABEL }}
                </h4>
              </v-col>
              <table style="width: 100%" class="table">
                <tr>
                  <th></th>
                  <th v-for="(label, idx) in elem.data.labels" :key="idx">{{ label }}</th>
                </tr>
                <tr v-for="(data, idx) in elem.data.datasets" :key="idx">
                  <td>{{ data.label }}</td>
                  <td v-for="(value, idx2) in data.data" :key="idx2">
                    {{ value }}
                  </td>
                </tr>
                <tr style="background-color: #e8f5e9">
                  <td style="font-weight: bold">Total</td>
                  <td
                    v-for="(label, idx) in elem.data.labels"
                    :key="idx"
                    style="font-weight: bold"
                  >
                    {{
                      elem.data.datasets
                        .map((val) => val.data)
                        .reduce((acc, ligne) => acc + ligne[idx], 0)
                    }}
                  </td>
                </tr>
              </table>
            </v-col>
            <v-col class="pt-6" v-else>
              <component
                :is="elem.STATS_TYPE"
                :chartData="elem.data"
                :options="getOptions(elem)"
              >
              </component>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
      <div v-else style="margin-top: 30vh" align="center">
        <v-progress-circular
          v-if="dataIsValide"
          :size="200"
          :width="7"
          color="#5C6BC0"
          bg-color="lightgrey"
          indeterminate
          >Chargement</v-progress-circular
        >
        <v-col v-else cols="10">
          <v-card class="pa-3">
            Aucune donnée disponible pour les dates sélectionnées
          </v-card>
        </v-col>
      </div>
    </v-col>
    <!-- <v-col class="pa-1" align="center">
      <v-btn COLOR="#7986CB" @click="save_html_into_pdf" style="width:100%;color:black" density="compact">
        Exporter
      </v-btn>
    </v-col> -->
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import engine from "../core/DataApi";
import Datepicker from "@vuepic/vue-datepicker";
import moment from "moment";
import { BarChart, DoughnutChart, LineChart } from "vue-chart-3";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Vue3EasyDataTable from "vue3-easy-data-table";
import { ref } from "@vue/reactivity";
import { computed } from "@vue/runtime-core";

export default {
  setup() {
    const dataIsValide = ref(true);
    const isExelOpen = ref(false);
    const selectedBase = ref(undefined);
    const selectedbtnIndex = ref(3);
    const btnListe = ref([
      { label: "12 Mois", subvalue: 12, subType: "M" },
      { label: "6 Mois", subvalue: 6, subType: "M" },
      { label: "3 Mois", subvalue: 3, subType: "M" },
      { label: "1 Mois", subvalue: 1, subType: "M" },
      { label: "Personnaliser", subvalue: undefined, subType: undefined },
    ]);
    const date = ref({ from: undefined, to: undefined });
    const statistiqueCreatedListe = ref({});
    const savedData = ref({});
    const statistiqueListe = ref(undefined);

    const openExelData = function () {
      isExelOpen.value = true;
    };

    const setDate = function (elem, i) {
      selectedbtnIndex.value = i;
      if (elem.subvalue && elem.subType) {
        date.value.from = moment()
          .subtract(elem.subvalue, elem.subType)
          .format("MM/DD/YYYY");
        date.value.to = moment().format("MM/DD/YYYY");
        setNewDataChart();
      }
    };

    const getOptions = function (elem) {
      let option = {};
      if (elem.IS_HORIZONTALE == 1) {
        option = JSON.parse(JSON.stringify(getChartHorizontalOptions.value));
      } else {
        option = JSON.parse(JSON.stringify(getChartOptions.value));
      }

      if (elem.STATS_TYPE == "DoughnutChart") {
        let donutsOption = {
          title: {
            display: true,
            text: elem.LABEL,
          },
          datalabels: {
            display: true,
            formatter: (val, ctx) => {
              const label = ctx.chart.data.labels[ctx.dataIndex];
              if (typeof parseFloat(val) === "number")
                return label + " : " + parseFloat(val).toFixed(2);
              else return label + " : " + val;
            },
            color: "#fff",
            borderRadius: "5",
          },
        };
        option.plugins = Object.assign({}, donutsOption, option.plugins);
        option.plugins["tooltip"] = {
          enabled: true,
          intersect: false,
          mode: "point",
        };
        option.interaction = {
          mode: "point",
        };
      }
      if (elem.IS_COMPLEX == "1" || elem.STATS_TYPE == "DoughnutChart") {
        let complexOption = {
          title: {
            display: true,
            text: elem.LABEL,
          },
        };
        option.plugins = Object.assign({}, option.plugins, complexOption);
      }

      return option;
    };

    const stringToHexColor = function (str) {
      // Créer une valeur de hachage numérique à partir de la chaîne
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      // Utiliser cette valeur pour générer une couleur hexadécimale
      let color = "#";
      for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff; // Extraire les 8 bits
        color += ("00" + value.toString(16)).slice(-2); // Convertir en hex et ajouter au résultat
      }

      return color;
    };

    const getComplexChartData = function (finalData, bddDataAdded, colors, params) {
      let yAxisData = [];
      let yAxisDataCtn = {};
      let xAxisData = Object.keys(bddDataAdded);
      finalData.labels = xAxisData;

      for (const [key, value] of Object.entries(bddDataAdded)) {
        for (const [key2, value2] of Object.entries(value)) {
          if (yAxisDataCtn[key2] && yAxisDataCtn[key2][key]) {
            yAxisDataCtn[key2][key] += value2;
          } else {
            if (yAxisDataCtn[key2] == undefined) yAxisDataCtn[key2] = {};
            yAxisDataCtn[key2][key] = value2;
          }
          if (!yAxisData.includes(key2)) yAxisData.push(key2);
        }
      }

      for (let i = 0; i < yAxisData.length; i++) {
        let tmpData = new Array(xAxisData.length).fill(0);
        for (let a = 0; a < tmpData.length; a++) {
          let key = xAxisData[a];
          let findedRes = yAxisDataCtn[yAxisData[i]][key];
          tmpData[a] = findedRes == undefined ? 0 : findedRes;
        }
        let dataWithOption = {
          borderWidth: 1,
          hoverBorderColor: "red",
          scaleStepWidth: 1,
          backgroundColor: colors,
          datalabels: {
            formatter: (val) => {
              if (typeof parseFloat(val) === "number") return parseFloat(val).toFixed(2);
              else return val;
            },
            COLOR: "black",
            anchor: params.IS_HORIZONTALE == "1" ? "center" : "center",
            align: params.IS_HORIZONTALE == "1" ? "end" : "end",
            labels: {
              title: {
                font: {
                  weight: "bold",
                  size: 11,
                },
              },
            },
            color: "black",
            // backgroundColor: '#404040',
            // borderRadius: '5'
          },
        };
        dataWithOption["label"] = yAxisData[i];
        dataWithOption["data"] = tmpData;
        // dataWithOption["backgroundColor"] = i % 2 == 0 ? colors[0] : colors[1];

        dataWithOption["backgroundColor"] = stringToHexColor(yAxisData[i]);
        // dataWithOption["backgroundColor"] = colors[i] == undefined ?colors[0]: colors[i];
        finalData.datasets.push(dataWithOption);
      }
      return finalData;
    };

    const getStatistiqueListe = function () {
      engine.getStatistiqueListe(function (data) {
        if (data.code == 0) {
          statistiqueListe.value = data.data.data.map((val) => val.fieldData);
          setNewDataChart();
        }
      });
    };

    const save_html_into_pdf = function () {
      window.scrollTo(0, 0);
      // let that = this;

      let data = document.querySelector("#captureMateriel");

      // data.style.width = "1000px";
      data.style.backgroundColor = "white";

      // data.style.border = "solid 1px lightgrey";
      let html2canvasOptions = {
        allowTaint: true,
        removeContainer: true,
        backgroundColor: null,
        imageTimeout: 15000,
        logging: true,
        scale: 2,
        useCORS: true,
        processData: false,
        contentType: false,
        // windowWidth: 1600,
        // windowHeight: 1600,
      };
      html2canvas(data, html2canvasOptions).then(async (canvas) => {
        // optionsTab.style.display = 'block'
        var imgData = await canvas.toDataURL("image/png");
        var imgWidth = 204;
        var imgHeight = 150;
        var position = 3;
        var pageHeight = 300;
        var heightLeft = imgHeight - pageHeight;

        var doc = new jsPDF("p", "mm");
        doc.addImage(imgData, "PNG", 3, position, imgWidth, imgHeight, undefined, "FAST");

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight + 10;
          doc.addPage();
          doc.addImage(
            imgData,
            "PNG",
            3,
            position,
            imgWidth,
            imgHeight,
            undefined,
            "FAST"
          );
          heightLeft -= pageHeight;
        }

        var link = document.createElement("a");
        link.href = doc.output("datauristring");
        link.download = "export_statistique.pdf";
        link.dispatchEvent(new MouseEvent("click"));
        data.style.backgroundColor = "transparent";
      });
    };

    const setNewDataChart = function () {
      console.log("setNewDataChart");

      statistiqueCreatedListe.value = {};
      initMoteurCharts();
      initReglementCharts();
      initContratCharts();
    };

    const initReglementCharts = function () {
      let formData = [{ date_reglement: date.value.from + "..." + date.value.to }];

      dataIsValide.value = true;
      if (savedData.value["reglement" + date.value.from + "..." + date.value.to]) {
        let bddData =
          savedData.value["reglement" + date.value.from + "..." + date.value.to];
        for (let i = 0; i < statistiqueListe.value.length; i++) {
          if (statistiqueListe.value[i].BASE == "reglement") {
            addStat(statistiqueListe.value[i], bddData);
          }
        }
      } else {
        engine.getReglementData(formData, function (data) {
          if (data.code == 0) {
            let bddData = data.data.data.map((val) => val.fieldData);
            savedData.value[
              "reglement" + date.value.from + "..." + date.value.to
            ] = bddData;
            for (let i = 0; i < statistiqueListe.value.length; i++) {
              if (statistiqueListe.value[i].BASE == "reglement") {
                addStat(statistiqueListe.value[i], bddData);
              }
            }
          } else {
            dataIsValide.value = false;
          }
        });
      }
    };

    const initMoteurCharts = function () {
      let formData = [{ Mot_Date: date.value.from + "..." + date.value.to }];

      dataIsValide.value = true;
      if (savedData.value["moteur" + date.value.from + "..." + date.value.to]) {
        let bddData = savedData.value["moteur" + date.value.from + "..." + date.value.to];
        for (let i = 0; i < statistiqueListe.value.length; i++) {
          if (statistiqueListe.value[i].BASE == "moteur") {
            addStat(statistiqueListe.value[i], bddData);
          }
        }
      } else {
        engine.getMoteurData(formData, function (data) {
          if (data.code == 0) {
            let bddData = data.data.data.map((val) => val.fieldData);
            savedData.value["moteur" + date.value.from + "..." + date.value.to] = bddData;
            for (let i = 0; i < statistiqueListe.value.length; i++) {
              if (statistiqueListe.value[i].BASE == "moteur") {
                addStat(statistiqueListe.value[i], bddData);
              }
            }
          } else {
            dataIsValide.value = false;
          }
        });
      }
    };

    const initContratCharts = function () {
      for (let i = 0; i < statistiqueListe.value.length; i++) {
        if (statistiqueListe.value[i].BASE == "contrat") {
          if (statistiqueListe.value[i].FILTRE) {
            let filter = statistiqueListe.value[i].FILTRE.replaceAll(
              "from",
              date.value.from
            ).replaceAll("to", date.value.to);
            filter = JSON.parse(filter);

            if (savedData.value["contrat" + date.value.from + "..." + date.value.to]) {
              let bddData =
                savedData.value["contrat" + date.value.from + "..." + date.value.to];
              addStat(statistiqueListe.value[i], bddData);
            } else {
              engine.getContratData(filter, function (data) {
                if (data.code == 0) {
                  let bddData = data.data.data.map((val) => val.fieldData);
                  savedData.value[
                    "contrat" + date.value.from + "..." + date.value.to
                  ] = bddData;
                  addStat(statistiqueListe.value[i], bddData);
                }
              });
            }
          }
        }
      }
    };

    const addStat = function (data, bddData) {
      statistiqueCreatedListe.value[data.INDEX] = data;
      searchStatsFilterByPrams(data, bddData);
    };

    const searchStatsFilterByPrams = function (params, bddData) {
      let keys = params.STATS_KEYS.split(",");
      let bddDataAdded = {};

      for (let i = 0; i < bddData.length; i++) {
        let key = bddData[i][keys[0]];
        let key2 = bddData[i][keys[1]];

        if (params.IS_COMPLEX == "1") {
          if (bddDataAdded[key] && bddDataAdded[key][key2]) {
            bddDataAdded[key][key2] += 1;
          } else {
            if (bddDataAdded[key]) {
              bddDataAdded[key][key2] = 1;
            } else {
              bddDataAdded[key] = {};
              bddDataAdded[key][key2] = 1;
            }
          }
        } else {
          // console.log("IS NUMBER" , typeof key2 === "number");

          if (typeof key2 === "number") {
            if (bddDataAdded[key]) {
              bddDataAdded[key] += key2;
            } else {
              bddDataAdded[key] = key2;
            }
          } else {
            if (bddDataAdded[key]) {
              bddDataAdded[key] += 1;
            } else {
              bddDataAdded[key] = 1;
            }
          }
        }
      }

      let colors = [];
      let finalData = {
        labels: [],
        datasets: [],
      };

      if (params.COLOR.includes(",")) colors = params.COLOR.split(",");
      else colors = [params.COLOR];

      let options = {
        borderWidth: 1,
        hoverBorderColor: "red",
        scaleStepWidth: 1,
        label: params.LABEL,
        backgroundColor: colors,
        datalabels: {
          formatter: (val) => {
            if (typeof parseFloat(val) === "number") return parseFloat(val).toFixed(2);
            else return val;
          },
          COLOR: "black",
          anchor: params.IS_HORIZONTALE == "1" ? "center" : "center",
          align: params.IS_HORIZONTALE == "1" ? "end" : "end",
          labels: {
            title: {
              font: {
                weight: "bold",
                size: 11,
              },
            },
          },
          color: "black",
        },
      };

      options = JSON.parse(JSON.stringify(options));

      if (params.IS_COMPLEX != "1") {
        finalData["datasets"] = [options];
      }

      if (params.IS_COMPLEX == "1") {
        finalData = getComplexChartData(finalData, bddDataAdded, colors, params);
      } else {
        let datasets = [];
        for (const [key, value] of Object.entries(bddDataAdded)) {
          finalData.labels.push(key);
          datasets.push(value);
        }
        finalData.datasets[0]["data"] = datasets;
      }
      params.data = finalData;
    };

    const getChartHorizontalOptions = computed(function () {
      return {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: "index",
          axis: "y",
        },
        plugins: {
          tooltip: {
            intersect: false,
            axis: "y",
          },

          title: {
            display: "red",
          },
          legend: {
            // position: 'bottom',
            title: {
              fontColor: "red",
            },
            labels: {
              COLOR: "#424242",
              font: {
                size: 16,
                weight: "bold",
              },
            },
          },
        },
      };
    });

    const getExelContent = computed(function () {
      let exelContent = {};

      for (const elem of Object.values(
        JSON.parse(JSON.stringify(statistiqueCreatedListe.value))
      )) {
        console.log("elem", elem.BASE);

        // if (elem.INDEX >= 0) {
        let title = elem.LABEL;
        let colone = [{ key: "label", label: "" }];
        let ligne = [];

        if (elem.IS_COMPLEX == 1) {
          let coloneDynamique = elem.data.labels.map((val) => ({
            key: val,
            label: val,
          }));

          colone = colone.concat(coloneDynamique);

          for (let i = 0; i < elem.data.datasets.length; i++) {
            let data = elem.data.datasets[i].data;
            let obj = { label: elem.data.datasets[i].label };

            for (let a = 0; a < elem.data.labels.length; a++) {
              obj[elem.data.labels[a]] = data[a];
            }
            ligne.push(obj);
          }
        } else {
          let coloneDynamique = elem.data.datasets.map((val) => ({
            key: val.label,
            label: val.label,
          }));

          colone = colone.concat(coloneDynamique);

          for (let i = 0; i < elem.data.datasets.length; i++) {
            let data = elem.data.datasets[i].data;

            for (let a = 0; a < elem.data.labels.length; a++) {
              let obj = { label: elem.data.labels[a] };

              obj[elem.LABEL] = data[a];
              ligne.push(obj);
            }
          }
        }
        exelContent[elem.STATS_KEYS] = {
          title,
          colone,
          ligne,
          base: elem.BASE,
          isComplex: elem.IS_COMPLEX,
        };
      }

      console.log("exelContent", exelContent);

      return exelContent;
    });

    const exportToExcel = function () {
      const wb = XLSX.utils.book_new();

      for (const key in getExelContent.value) {
        const bloc = getExelContent.value[key];
        const headers = bloc.colone.map((c) => c.label || c.key);
        const rows = bloc.ligne.map((row) => headers.map((h) => row[h] ?? ""));
        const sheetData = [headers, ...rows];
        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        const sheetName = bloc.title.substring(0, 31);
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      }

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });

      saveAs(blob, "rapport.xlsx");
    };

    const getChartOptions = computed(function () {
      let option = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: "index",
        },
        plugins: {
          tooltip: {
            intersect: false,
            axis: "x",
            // enabled: false,
            // intersect: false,
            // mode: "index",
          },
          title: {
            display: "red",
          },
          legend: {
            // position: 'bottom',
            title: {
              fontColor: "red",
            },
            labels: {
              COLOR: "#424242",
              font: {
                size: 16,
                weight: "bold",
              },
            },
          },
        },
      };

      return option;
    });

    return {
      statistiqueCreatedListe,
      openExelData,
      isExelOpen,
      setDate,
      getOptions,
      stringToHexColor,
      getComplexChartData,
      getStatistiqueListe,
      save_html_into_pdf,
      btnListe,
      getExelContent,
      selectedbtnIndex,
      date,
      selectedBase,
      setNewDataChart,
      exportToExcel,
    };
  },
  methods: {
    formatDate(date, format) {
      return moment(date).format(format);
    },
  },
  components: { BarChart, DoughnutChart, LineChart, Datepicker, Vue3EasyDataTable },
  mounted() {
    this.date.from = moment()
      .subtract(this.btnListe[this.selectedbtnIndex].subvalue * 30, "d")
      .format("MM/DD/YYYY");
    this.date.to = moment().format("MM/DD/YYYY");

    this.getStatistiqueListe();
  },
};
</script>

<style>
@import "../style.css";
</style>
